import templateUrl from 'servicestack/auto-query/auto-query-breadcrumbs.htm'
import AutoQueryBreadcrumbsController from 'servicestack/auto-query/auto-query-breadcrumbs.controller'

let AutoQueryBreadcrumbsComponent = {
    bindings: {
        navs: '<'
    },
    require:{
        //container: '^AutoQueryContainer'
    },
    controller: AutoQueryBreadcrumbsController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
};

export default AutoQueryBreadcrumbsComponent;
